import { API_URL } from "../../../../constants";
import * as httpNetworking from "../../../../httpNetworking";

const VERSION = 2;
const URL = API_URL + "/saas/multi-tenancy/connection-uri-domain";

export async function createMultiTenancyApp(data: {
    deploymentType?: "development" | "production";
    region: string;
    deploymentId?: string;
    cancelURL: string;
    successURL: string;
}): Promise<void> {
    const options: httpNetworking.GETRequestConfig = {
        timeout: 60000
    };

    const _deploymentType = data.deploymentType || "development";

    await httpNetworking.simplePOSTRequest(
        URL,
        {
            ...data,
            deploymentType: _deploymentType
        },
        options,
        VERSION
    );
}
